import React, { useState, useEffect } from "react";
import { Column, TotalItem, Summary, HeaderFilter, FilterRow, FilterPanel } from "devextreme-react/data-grid";
import DateBox from 'devextreme-react/date-box';
import { PaginaReporte } from "../../../Componentes/Compuestos/Paginas/PaginaReporte";
import { LVGridCabeceraReporte } from "../../../Componentes/Basicos/LVGridCabeceraReporte";
import ComboAbmEexClientes from "../../../Componentes/Compuestos/Combos/ComboAbmEexClientes";
import { Navigate } from "react-router-dom";
import { function_VEN_Pedidos_Cabecera_ReportePedido } from "neftis7_apicaller/src/funciones/VEN/Pedidos/VEN_Pedidos_Cabecera";
import { function_VEN_DocsVenta_Cabecera_ReporteDocVenta } from "neftis7_apicaller/src/funciones/VEN/DocsVenta/VEN_DocsVenta_Cabecera";
import { function_VEN_Recibos_Cabecera_ReporteRecibo } from "neftis7_apicaller/src/funciones/VEN/Recibos/VEN_Recibos_Cabecera";
import { function_INV_Remitos_Cabecera_ReporteRemito } from "neftis7_apicaller/src/funciones/INV/Remitos/INV_Remitos_Cabecera";

export const CON_Reporte_Cliente = () => {
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState([])
  const [IdCliente, setIdCliente] = useState("")
  const { VariablesGenerales: { DiasParaDesdeListados, DiasParaHastaListados } } = require('neftis7_apicaller');
  const [FechaDesde, setFechaDesde] = useState(new Date(DiasParaDesdeListados !== 0 ? new Date().setDate(new Date().getDate() + DiasParaDesdeListados) : Date.now()));
  const [FechaHasta, setFechaHasta] = useState(new Date(DiasParaHastaListados !== 0 ? new Date().setDate(new Date().getDate() + DiasParaHastaListados) : Date.now()));
  const { CONT_Reportes: { function_CONT_Reportes_ClientesConSaldo } } = require('neftis7_apicaller');

  const onValueChangedFechaDesde = (nuevaFecha) => {
    setFechaDesde(nuevaFecha.value);
  };

  const onValueChangedFechaHasta = (nuevaFecha) => {
    setFechaHasta(nuevaFecha.value);
  };

  const onValueChangedIdCliente = (nuevoCodigo) => {
    setIdCliente(nuevoCodigo.value);
  };

  const getData = async () => {
    // Llama a función asíncrona y maneja los datos
    try {
      if (IdCliente && IdCliente > 0) {
        let resultData = await function_CONT_Reportes_ClientesConSaldo(IdCliente);

        setData(resultData.data)
      }
    } catch (error) {
      alert("Error al obtener los datos: " + error);
    }
    setLoading(false)
  };

  useEffect(() => {
    getData();
  }, [FechaDesde, FechaHasta, IdCliente]); // Llamar a getData cuando FechaDesde o FechaHasta cambien

  useEffect(() => {
    const user = localStorage.getItem("user");
    const codigoCompania = localStorage.getItem("CodigoCompania");
    const codigoEmpresa = localStorage.getItem("CodigoEmpresa");
    const codigoPlanta = localStorage.getItem("CodigoPlanta");
    const idPersona = localStorage.getItem("IdPersona");

    // Verificar valores en localStorage
    if (!user || !codigoCompania || !codigoEmpresa || !codigoPlanta || Number(idPersona) < 1) {
      if (Number(idPersona) === -1 || Number(idPersona) === -2 || Number(idPersona) === -3) {
      } else {
        return <Navigate to={"/Login"} />;
      }
    }
  }, []);

  const handleOnClick_Operacion = async (IdTipo, IdOperacion) => {
    setLoading(true)
    try {
      const formato = "pdf"
      let titulo = ""
      let reportData

      if (IdTipo == 101 || IdTipo == 102) {
        reportData = await function_VEN_Pedidos_Cabecera_ReportePedido(IdOperacion, formato);
        titulo = "PedidoVenta"
      }

      if (IdTipo == 1 || IdTipo == 2 || IdTipo == 3 || IdTipo == 11 || IdTipo == 12 || IdTipo == 13 ||
        IdTipo == 21 || IdTipo == 22 || IdTipo == 23 || IdTipo == 31 || IdTipo == 32 || IdTipo == 33 ||
        IdTipo == 41 || IdTipo == 42 || IdTipo == 43 || IdTipo == 51 || IdTipo == 52 || IdTipo == 53 ||
        IdTipo == 61 || IdTipo == 62 || IdTipo == 63 || IdTipo == 71 || IdTipo == 72 || IdTipo == 73 ||
        IdTipo == 81 || IdTipo == 82 || IdTipo == 83 || IdTipo == 91 || IdTipo == 92 || IdTipo == 93) {
        reportData = await function_VEN_DocsVenta_Cabecera_ReporteDocVenta(IdOperacion, formato);
        titulo = "DocVenta"
      }

      if (IdTipo == 208) {
        reportData = await function_VEN_Recibos_Cabecera_ReporteRecibo(IdOperacion, formato);
        titulo = "Recibo"
      }
      if (IdTipo == 301) {
        reportData = await function_INV_Remitos_Cabecera_ReporteRemito(IdOperacion, formato);
        titulo = "Remito"
      }

      if (reportData) {
        if (formato === 'pdf') {
          const file = new Blob([reportData], { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          const link = document.createElement('a');
          link.href = fileURL;
          link.download = `${titulo}${IdOperacion}.pdf`; // Nombre del archivo con extensión
          link.click();
        } else if (formato === 'html') {
          const htmlContent = reportData.data;
          const newWindow = window.open();
          newWindow.document.write(htmlContent); // Mostrar HTML en nueva ventana
          newWindow.document.close();
        }
      } else {
        alert("El Tipo " + IdTipo + " es desconocido");
      }
    } catch (error) {
      alert("Error al obtener los datos:" + error);
    }
    setLoading(false)
  };

  return (
    <PaginaReporte
      Titulo="CUENTA CORRIENTE CLIENTE"
    >
      {loading ? (
        <div className="card-body text-center">
          <div className="spinner-border" role="status">
            <span className="sr-only">Cargando...</span>
          </div>
        </div>
      ) : (
        <div className="card-body">

          <table >
            <tbody>
              <tr>
                <td width={120}>

                </td>
                <td width={130}>
                  <DateBox width={160} displayFormat="dd/MM/yyyy" value={FechaDesde} onValueChanged={onValueChangedFechaDesde} visible={false} />
                </td>
                <td width={130}>
                  <DateBox width={160} displayFormat="dd/MM/yyyy" value={FechaHasta} onValueChanged={onValueChangedFechaHasta} visible={false} />
                </td>
                <td width={130}>
                  <ComboAbmEexClientes onValueChanged={onValueChangedIdCliente} ancho="500" />
                </td>
              </tr>
            </tbody>
          </table>
          <div className="table-responsive">
            {data.length > 0 ? (
              <LVGridCabeceraReporte
                dataSource={data}
                id="gridContainer"
              >
                <HeaderFilter visible={false} />
                <FilterPanel visible={false} />
                <FilterRow visible={false} />
                <Summary>
                  <TotalItem
                    column="Id"
                    summaryType="count"
                    customizeText={summaryItem => `Registros: ${summaryItem.value}`} />

                </Summary>

                <Column caption="Operación" dataField="Id" width="120" alignment="Right" dataType="number" allowSorting={false}
                  cellRender={({ data }) => (
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        handleOnClick_Operacion(data.IdTipo, data.Id);
                      }}
                    >
                      {data.Id}
                    </a>
                  )}
                />
                <Column caption="Tipo" dataField="Tipo" width="200" alignment="Left" dataType="string" allowSorting={false} />
                <Column caption="Fecha" dataField="Fecha" width="100" alignment="Right" dataType="date" format={'dd/MM/yyyy'} filterOperations={['between']} allowSorting={false} />

                <Column caption="Cliente" alignment="Center" >
                  <Column caption="Código" dataField="IdCliente" width="70" alignment="Right" dataType="number" allowSorting={false} />
                  <Column caption="Descripción" dataField="ABM_EEX_Clientes_RazonSocial" width="200" alignment="Left" dataType="string" allowSorting={false} />
                </Column>
                <Column caption="Documento" dataField="NumeroFantasia" width="200" alignment="Left" dataType="string" allowSorting={false} />
                <Column caption="Concepto" dataField="Concepto" width="200" alignment="Left" dataType="string" allowSorting={false} />
                <Column caption="Observaciones" dataField="Observaciones" width="200" alignment="Left" dataType="string" allowSorting={false} />

                <Column caption="Importes" alignment="Center">
                  <Column caption="Debe" dataField="Debe" width="150" alignment="Right" dataType="number" format="currency" allowSorting={false} />
                  <Column caption="Haber" dataField="Haber" width="150" alignment="Right" dataType="number" format="currency" allowSorting={false} />
                  <Column caption="Saldo" dataField="Saldo" width="150" alignment="Right" dataType="number" format="currency" allowSorting={false} />
                </Column>

              </LVGridCabeceraReporte>
            ) : (
              <div className="card-body text-center">
                <h5 className="card-title">No hay datos</h5>
              </div>
            )}
          </div>
        </div>
      )}
    </PaginaReporte>
  );
};
